export default image => !!image && Object.keys(image).length;
